import React from "react";
import { Form, Col } from "react-bootstrap";
import { Typeahead } from "react-bootstrap-typeahead";
import { itemTypes } from "../constants";

export default function ItemTypesPicker({ formData, setFormData, name, filterFunction = () => true, colXl = 6, inputOnly = false }) {
    const input = (
        <Typeahead
            id={`${name}-item-types-selection`}
            options={itemTypes.filter(filterFunction)}
            labelKey={"label"}
            placeholder="Select item types..."
            highlightOnlyResult
            multiple
            clearButton
            selected={formData.itemTypes}
            onChange={value => setFormData({ ...formData, itemTypes: value })}
        />
    );

    if (inputOnly) {
        return input;
    }

    return (
        <Form.Group as={Col} className={`col-12 col-xl-${colXl}`}>
            <Form.Label>Item Types</Form.Label>
            {input}
        </Form.Group>
    );
}
